<template lang="html">
  <div class="MapPopup" v-if="zipcode">
    <p class="MapPopup-zip">Zip Code: {{zipcode}}</p>
    <div v-if="distance">{{ distance }} miles away</div>
    <ul class="MapPopup-details">
      <li class="u-mt2" v-for="(squad, index) in squads" :key="squad.id">
        <p class="u-mb1">
          {{ squad.name }}<br>
          District: {{ squad.district_name }}<br>
          Squad Leader: {{ squad.firstName }} {{ squad.lastName }}<br>
          <span v-if="squad.website">
            Website: {{ squad.website }}
          </span>
        </p>
        <a @click="joinSquad(squad)" class="Button Button--outline Button--small">Join This Squad</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  props: {
    zipcode: {
      type: String,
      required: false
    },
    squads: {
      type: Array,
      required: false
    },
    distance: {
      type: Number,
      required: false
    }
  },

  mounted() {
  },

  methods: {
    joinSquad(squad) {
      this.$store.commit('squadSearch/setSquad', squad);
      this.$store.commit('squadSearch/setJoining', true);
    }
  }
};
</script>



// WEBPACK FOOTER //
// map-popup-squad.vue?63e44faf